import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Send } from "lucide-react";

const KIND_LABEL = {
  absence_alert: { label: "تنبيه غياب", color: "bg-rose-100 text-rose-700" },
  announcement: { label: "إعلان", color: "bg-sky-100 text-sky-700" },
  private_message: { label: "رسالة خاصة", color: "bg-emerald-100 text-emerald-700" },
  daily_report: { label: "تقرير يومي", color: "bg-amber-100 text-amber-700" },
  session_reminder: { label: "تذكير جلسة", color: "bg-purple-100 text-purple-700" },
  monthly_report: { label: "تقرير شهري", color: "bg-sky-100 text-sky-700" },
  emergency_alert: { label: "تنبيه طارئ", color: "bg-rose-600 text-white" },
  report_followup: { label: "متابعة تقرير", color: "bg-fuchsia-100 text-fuchsia-700" },
};

const DELIVERY_LABEL = {
  queued: { label: "في الطابور", color: "bg-slate-100 text-slate-700" },
  sending: { label: "جاري الإرسال", color: "bg-sky-100 text-sky-700" },
  sent: { label: "أُرسل", color: "bg-sky-100 text-sky-700" },
  delivered: { label: "وصل", color: "bg-emerald-100 text-emerald-700" },
  read: { label: "قُرئ", color: "bg-emerald-600 text-white" },
  failed: { label: "فشل", color: "bg-rose-100 text-rose-700" },
  undelivered: { label: "لم يُسلَّم", color: "bg-rose-100 text-rose-700" },
};

export default function WhatsAppLogPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/whatsapp-log").then(({ data }) => setItems(data)); }, []);

  return (
    <div className="space-y-6" data-testid="whatsapp-page">
      <div>
        <h1 className="text-3xl md:text-4xl font-black text-slate-900">سجل إشعارات الواتساب</h1>
        <p className="text-slate-500 mt-2">
          محاكاة الرسائل المُرسلة عبر Twilio WhatsApp Business API (سيتم التفعيل الفعلي عند إضافة المفاتيح)
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map((m) => {
          const meta = KIND_LABEL[m.kind] || { label: m.kind, color: "bg-slate-100 text-slate-700" };
          const del = m.delivery_status ? DELIVERY_LABEL[m.delivery_status] : null;
          return (
            <Card key={m.id} data-testid={`wa-${m.id}`} className="border-slate-200/70 card-elevated">
              <CardContent className="p-5">
                <div className="flex items-start justify-between mb-3 gap-2">
                  <div className="flex items-center gap-2">
                    <div className="w-9 h-9 rounded-lg bg-emerald-500 text-white flex items-center justify-center">
                      <Send className="w-4 h-4" />
                    </div>
                    <div>
                      <div className="font-black text-slate-900">{m.to_name}</div>
                      <div className="text-xs text-slate-500" dir="ltr">{m.to_phone || "—"}</div>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-1.5 justify-end">
                    <Badge className={`${meta.color} hover:${meta.color}`}>{meta.label}</Badge>
                    {m.template_key && <Badge variant="outline" className="border-emerald-300 text-emerald-700">قالب</Badge>}
                    {del && <Badge className={`${del.color} hover:${del.color}`}>{del.label}</Badge>}
                    {!del && m.status === "simulated" && <Badge variant="outline" className="text-slate-500">محاكاة</Badge>}
                    {m.status === "failed" && !del && <Badge className="bg-rose-100 text-rose-700 hover:bg-rose-100">فشل</Badge>}
                  </div>
                </div>
                <div className="text-sm text-slate-700 bg-emerald-50 border border-emerald-100 rounded-lg p-3 whitespace-pre-wrap">
                  {m.body}
                </div>
                <div className="text-[10px] text-slate-400 mt-2 flex items-center gap-2 flex-wrap">
                  <span>{new Date(m.timestamp).toLocaleString("ar-EG")}</span>
                  {m.twilio_sid && <span dir="ltr" className="font-mono">· SID {m.twilio_sid.slice(0, 10)}…</span>}
                  {m.media_url && <span>· 📎 مرفق</span>}
                </div>
              </CardContent>
            </Card>
          );
        })}
        {items.length === 0 && <Card className="md:col-span-2"><CardContent className="p-16 text-center text-slate-400">لا توجد إشعارات بعد</CardContent></Card>}
      </div>
    </div>
  );
}
